export const CalculateOffsetRight = (el) => {
  return window.innerWidth - el.offsetLeft - el.offsetWidth
}
